import React, { useState } from "react";

import { Button } from "@app/scripts/react-general-components/Button";
import { Drawer } from "@app/scripts/react-general-components/Drawer";
import { useMobile } from "@app/scripts/react-hooks/mobile";
import config from "@app/config";
import { AustraliaSvg } from "@app/scripts/react-geolocation/components/AustraliaSvg";

export type GeolocationDrawerProps = {
  detectedCountry?: string;
  shopifyCountry?: string;
};

export const GeolocationDrawer: React.FC<GeolocationDrawerProps> = (props) => {
  const { shopifyCountry } = props;
  const isMobile = useMobile();

  const isNorthAmericaShopify = shopifyCountry == "US" || shopifyCountry == "CA";

  const button = () => (
    <div className="localization-form__selected">
      {isNorthAmericaShopify ? "United States" : "Australia"} / ${Shopify.currency.active}
      {shopifyCountry === "US" ? (
        <ui-icon name="icon-america"></ui-icon>
      ) : shopifyCountry === "CA" ? (
        <ui-icon name="icon-america"></ui-icon>
      ) : (
        <AustraliaSvg width={22} height={14} />
      )}
    </div>
  );

  return (
    <Drawer
      customButton={button}
      opensFrom={isMobile ? "bottom" : "right"}
      heading="Confirm Your Location"
      drawerClassName="geolocation__drawer"
    >
      <DrawerContent {...props} />
    </Drawer>
  );
};

const DrawerContent = ({ shopifyCountry, toggleOpen }) => {
  const [selected, setSelected] = useState<string>(shopifyCountry);

  const countryMatchesSelected =
    ((shopifyCountry === "US" || shopifyCountry === "CA") && (selected === "US" || selected === "CA")) ||
    (shopifyCountry !== "US" && shopifyCountry !== "CA" && selected === "AU");

  const btnText = countryMatchesSelected
    ? "Continue Shopping"
    : `Shop the ${selected === "US" || selected === "CA" ? "North American" : "Australian"} site`;

  const onClick = () => {
    const link =
      config.stores[selected === "US" || selected === "CA" ? "industrie-australia" : "industrie-clothing"].url;
    countryMatchesSelected ? toggleOpen?.() : (window.location.href = link);
  };

  return (
    <div className="geolocation__drawer-inner page-width text-brand-dark-grey">
      <div className="geolocation__drawer-buttons">
        <button
          onClick={() => setSelected("AU")}
          className="text-lg bold geolocation__drawer-bigbtn"
          style={{ borderColor: selected !== "CA" && selected !== "US" ? "black" : undefined }}
        >
          <ui-icon name="icon-globe"></ui-icon>
          Australia & Rest Of World
        </button>
        <button
          onClick={() => setSelected("US")}
          className="text-lg bold geolocation__drawer-bigbtn"
          style={{ borderColor: selected === "CA" || selected === "US" ? "black" : undefined }}
        >
          <div className="geolocation__popup-flags">
            <ui-icon name="icon-america"></ui-icon>
            <ui-icon name="icon-canada"></ui-icon>
          </div>
          North America
        </button>
      </div>
      <Button onClick={onClick} label={btnText} variant="secondary" className="fullwidth" />
    </div>
  );
};
